import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ArrowUpIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M8.5,1.09 L15.7,8.29 L14.3,9.71 L9.5,4.91 L9.5,15 L7.5,15 L7.5,4.91 L2.7,9.71 C1.76,8.79 1.3,8.31 1.3,8.29 C1.3,8.27 3.7,5.87 8.5,1.09 Z"
        data-testid="icon-arrowUp"
        fill={customColour}
        className={styles[className]}
      />
    </Icon>
  )
}
